<div
  class="card-tab-form content"
  [formGroup]="form">
  <app-input-person-autocomplete
    *ngIf="form?.controls?.fornitore"
    formControlName="fornitore">
  </app-input-person-autocomplete>
  <mat-form-field *ngIf="form?.controls?.tiratura">
    <input
      matInput
      formControlName="tiratura"
      [placeholder]="'Tiratura' | translate">
  </mat-form-field>
  <mat-form-field *ngIf="form?.controls?.patina">
    <input
      matInput
      formControlName="patina"
      [placeholder]="'Patina' | translate">
  </mat-form-field>
  <mat-form-field *ngIf="form?.controls?.note">
    <textarea
      matInput
      formControlName="note"
      rows="5"
      [placeholder]="'Note' | translate"></textarea>
  </mat-form-field>

  <h3>{{ 'Progetti' | translate }}</h3>
  <p *ngIf="(form?.controls?.progetti.value || []).length === 0">{{ 'Non sono presenti progetti.' }}</p>
  <app-project-form
    [form]="form?.controls?.progetti"
    [classNames]="classNames">
  </app-project-form>

  <ng-container
    formGroupName="prodotto"
    *ngIf="form?.controls?.prodotto">
    <h3>{{ 'Prodotto' | translate }}</h3>
    <mat-form-field>
      <input
        matInput
        type="number"
        formControlName="prezzoDiListino"
        [placeholder]="'Valore assicurativo' | translate">
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        type="number"
        formControlName="prezzoDiVendita"
        [placeholder]="'Prezzo Pub.Imp.' | translate">
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        type="number"
        formControlName="iva"
        [placeholder]="'IVA' | translate">
    </mat-form-field>
  </ng-container>
  <mat-checkbox
    [formControl]="isOperaMadreEnableControl"
    *ngIf="form?.controls?.operaMadre && !form?.controls?.benePadre?.value">
    {{ 'Opera madre' | translate }}
  </mat-checkbox>

  <ng-container
    *ngIf="isOperaMadreEnableControl.value && form?.controls?.operaMadre && !form?.controls?.benePadre?.value"
    formGroupName="operaMadre">
    <h3>{{ 'Opera madre' | translate }}</h3>
    <mat-form-field>
      <input
        matInput
        formControlName="tiratura"
        type="number"
        [placeholder]="'Tiratura' | translate">
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        type="number"
        formControlName="tiraturaEA"
        [placeholder]="'Tiratura EA' | translate">
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        formControlName="tiraturaHC"
        type="number"
        [placeholder]="'Tiratura HC' | translate">
    </mat-form-field>
    <div class="totals-container">
      <mat-card class="total-container">
        <span class="label">Opere prodotte</span>
        <span class="value">{{ productExamples$ | async }}</span>
      </mat-card>
      <mat-card
        class="total-container"
        [class.error]="productExamplesToProduct < 0"
        *ngIf="getProductExamplesToProduct(productExamples$ | async) as productExamplesToProduct">
        <span class="label">Opere da produrre</span>
        <span class="value">{{ productExamplesToProduct }}</span>
      </mat-card>
    </div>
    <div class="totals-container">
      <mat-card class="total-container">
        <span class="label">Opere numerate</span>
        <span class="value">{{ childNumberCount$ | async }}</span>
      </mat-card>

      <mat-card class="total-container">
        <span class="label">Opere prova d'artista</span>
        <span class="value">{{ childProvaCount$ | async }}</span>
      </mat-card>

      <mat-card class="total-container">
        <span class="label">Opere fuori commercio</span>
        <span class="value">{{ childFuoriCommercioCount$ | async }}</span>
      </mat-card>
    </div>
  </ng-container>

  <ng-container *ngIf="form?.controls?.benePadre?.value">
    <h3>{{ 'Opera madre' | translate }}</h3>
    <p>
      <a [routerLink]="['/cards/s/manager', form?.controls?.benePadre?.value]">
        {{ 'Vai alla visualizzazione della stampa madre' | translate }}
      </a>
    </p>
    <button
      *roleVisibility="['create', 'update']; classNames: classNames"
      mat-button
      mat-raised-button
      type="button"
      class="unlink-btn-card"
      [matTooltip]="'Per scollegare una scheda madre è necessario salvare una volta cliccato sul bottone: \'Scollega\'' | translate"
      [title]="'Per scollegare una scheda madre è necessario salvare una volta cliccato sul bottone: \'Scollega\'' | translate"
      (click)="unlinkParentCardHandler()">
      {{ 'Scollega scheda madre' | translate }}
    </button>
  </ng-container>

  <div *ngIf="form?.controls?.base">
    <h3>{{ 'Base' | translate }}</h3>
    <div *ngIf="base">
      <p>Titolo: {{ base?.titolo }}</p>
      <p>Codice unico: {{ base?.codiceUnico }}</p>
      <p>Note: {{ base?.note }}</p>
    </div>
    <button
      *roleVisibility="['create', 'update']; classNames: classNames"
      mat-button
      mat-raised-button
      type="button"
      (click)="showAddBaseDialogHandler()">
      {{ base ? 'Modifica base' : 'Aggiungi base'}}
    </button>
    <ng-container *roleVisibility="['create', 'update']; classNames: classNames">
      <button
        mat-button
        mat-raised-button
        type="button"
        *ngIf="base"
        [matTooltip]="'Per rimuovere una base è necessario salvare una volta cliccato sul bottone: \'Rimuovi\'' | translate"
        (click)="removeBaseHandler()">
        {{ 'Rimuovi base' | translate }}
      </button>
    </ng-container>
  </div>

  <h3>{{ 'Collegamenti Web' | translate }}</h3>
  <p *ngIf="(form?.controls?.collegamentiWeb.value || []).length === 0">{{ 'Non sono presenti collegamenti.' }}</p>
  <app-link-web-form [form]="form?.controls?.collegamentiWeb"></app-link-web-form>
</div>
